import React from 'react';

import { Content as CommonContent } from '../common/Types.jsx';
import { withBlockRendering } from '../utility/Config.jsx';
import Container from '../common/Container.jsx';
import { Component as ItemMetaComponent, TypeConfig as ItemMetaTypeConfig } from './ItemMeta.jsx';
import CellItemContainer from '../common/CellItemContainer.jsx';
import * as CellItemImage from '../common/CellItemImage.jsx';
import Name from '../utility/Name.jsx';
import { default as _TypeConfig } from '../common/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

const Blocks = {
    get: (group, data) => [
        ...CommonContent.get(group),
        {
            id: Name.Block.Inventory.Image,
            component: CellItemImage.Component,
            config: {
                Block: CellItemImage.TypeConfig.panel.block(),
                Style: CellItemImage.TypeConfig.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: ItemMetaComponent,
            config: {
                Block: ItemMetaTypeConfig.panel.block(),
                Style: ItemMetaTypeConfig.panel.style(),
                Description: ItemMetaTypeConfig.panel.description(),
                Label: ItemMetaTypeConfig.panel.label(),
                Value: ItemMetaTypeConfig.panel.value(data)
            },
            display: 'Item Meta',
            group,
            image: ''
        }
    ]
}

function ItemContainer(props) {
    const config = props.config || {};
    if (!props.builder && !props.forceVisibility && !Utilities.Config.getVisibility(config, 'Inventory')) {
        return null;
    }
    const artist = props.itemData || {};
    const inventory = artist.Inventory || [];
    if (!props.builder && inventory.length == 0) {
        return null;
    }
    const blockConfig = config.config && config.config.Block || {};
    let columnCount = 3;
    if (blockConfig.columnCount) {
        let temp = parseInt(blockConfig.columnCount, 10);
        if (!isNaN(temp) && temp > 0) {
            columnCount = temp;
        }
    }
    let contentConfig;
    if (blockConfig.design && blockConfig.design.Config && blockConfig.design.Config.blocks && blockConfig.design.Config.blocks.length > 0) {
        contentConfig = blockConfig.design;
    }
    let content = [];
    for (let i = 0; i < columnCount; i++) {
        if (i < inventory.length) {
            content.push(
                <td key={i} style={{ width: `${100.0 / columnCount}%` }}>
                    <ItemContentContainer
                        config={contentConfig}
                        data={props.data}
                        itemData={inventory[i]}
                        kit={props.kit}
                        serverSide={props.serverSide} />
                </td>
            )
        } else {
            content.push(<td key={i} style={{ width: `${100.0 / columnCount}%` }} />)
        }
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            dataType="layout"
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                {content}
                {
                    props.builder &&
                    <td>
                        {
                            !contentConfig &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                }
            </tr>
        </Container>
    );
}
const ItemContentContainer = withBlockRendering(CellItemContainer, Blocks.get(), (props) => {
    let data = props.itemData || props.data || {};
    if (data.Artists && data.Artists.length > 0 && data.Artists[0].Inventory && data.Artists[0].Inventory.length > 0) {
        data = data.Artists[0].Inventory[0];
    }
    return { itemData: data };
});

const TypeConfig = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "maxHeight": {
                                "unit": "px",
                                "value": "160"
                            },
                            "maxWidth": {
                                "unit": "px",
                                "value": "160"
                            }
                        },
                        "Style": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "20"
                            },
                            "textAlign": "left"
                        }
                    },
                    "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Image
                    }
                },
                {
                    "config": {
                        "Block": {
                            "count": "1",
                            "displayType": "columns",
                            "rowCount": "1"
                        },
                        "Style": {},
                        "Description": {},
                        "Label": {},
                        "Value": {
                            "design": ItemMetaTypeConfig.defaultDesign(data)
                        }
                    },
                    "id": `${Name.Block.Inventory.Meta}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Meta
                    }
                }
            ]
        },
        "Type": Name.Content.ArtistInventoryItem
    }),
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Item Count',
                        group,
                        name: 'columnCount',
                        options: [
                            { display: '1', value: '1' },
                            { display: '2', value: '2' },
                            { display: '3', value: '3' }
                        ],
                        type: 'dropdown',
                        value: '3'
                    },
                    {
                        display: 'Edit Item Content',
                        fullWidth: true,
                        group,
                        type: 'edit-button',
                        value: {
                            keyPath: ['Block', 'design'],
                            name: Name.Content.ArtistInventoryItem
                        }
                    }
                ]
            }
        },
        style: () => _TypeConfig.panel.layoutStyle('block', undefined, {}, undefined, {}),
        visibility: () => {
            return {
                options: [
                    {
                        configurableDuringExport: () => true,
                        display: 'Artworks',
                        name: 'Inventory',
                        type: 'checkbox',
                        value: true,
                        visible: () => false
                    }
                ]
            };
        }
    }
}

export {
    Blocks,
    ItemContentContainer as ContentContainer,
    ItemContainer as Component,
    TypeConfig
};